export const ProgressDotContainerStyle: React.CSSProperties = {
    display: 'flex',
    padding: '0px',
    marginTop: '-15px',
    flexDirection: 'row',
    transition: 'all ease 0.25s'
};
